import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3b8ca09b&scoped=true&lang=pug&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.styl?vue&type=style&index=0&id=3b8ca09b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ca09b",
  null
  
)

export default component.exports